import OriginalDivider from './Divider.svelte';
import Icon from './Icon.svelte';
import Label from './Label.svelte';
const Divider = OriginalDivider;
Divider.Icon = Icon;
Divider.Label = Label;
export default Divider;
